import RealTurnstile, { BoundTurnstileObject, TurnstileProps } from "react-turnstile";
export function Turnstile(props: TurnstileProps & { real?: boolean }) {
    if (props.real) {
        return <RealTurnstile {...props} />;
    }
    return <div className="fake-turnstile">
        <input type="checkbox" onChange={() => {
            if (props.onVerify) props.onVerify("fake-token", {} as BoundTurnstileObject);
        }} /> I'm not a robot
    </div>;
}
